import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=beautiful%20cat%20lying%20on%20a%20cat%20scratching%20board%20in%20a%20cozy%20modern%20home%20interior%2C%20warm%20natural%20light%20streaming%20through%20window%2C%20soft%20beige%20and%20warm%20brown%20tones%2C%20artistic%20lifestyle%20photography%2C%20minimalist%20Scandinavian%20interior%20design%2C%20peaceful%20atmosphere&width=1440&height=900&seq=hero1&orientation=landscape"
          alt="cat scratcher"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full text-center px-6 md:px-10 flex flex-col items-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white/80 text-xs font-medium mb-6 tracking-widest uppercase">
          {t('hero_badge')}
        </span>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 max-w-4xl">
          {t('hero_title1')}
          <br />
          <span className="text-[#f5c9a8]">{t('hero_title2')}</span>
          <br />
          {t('hero_title3')}
        </h1>

        <p className="text-white/75 text-base md:text-lg max-w-xl mt-4 mb-10 leading-relaxed">
          {t('hero_desc')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <Link
            to="/products"
            className="px-8 py-3.5 rounded-full bg-[#C8714A] text-white font-semibold text-sm hover:bg-[#b5603b] transition-all cursor-pointer whitespace-nowrap"
          >
            {t('hero_btn_products')}
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border border-white/60 text-white font-semibold text-sm hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
          >
            {t('hero_btn_about')}
          </Link>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row gap-8 sm:gap-16 items-center">
          {[
            { num: t('hero_stat1_num'), label: t('hero_stat1_label') },
            { num: t('hero_stat2_num'), label: t('hero_stat2_label') },
            { num: t('hero_stat3_num'), label: t('hero_stat3_label') },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl font-bold text-white">{stat.num}</div>
              <div className="text-white/60 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs">{t('hero_scroll')}</span>
        <i className="ri-arrow-down-line text-white/50 text-lg"></i>
      </div>
    </section>
  );
}
